import * as React from 'react';

const SvgWhatsapp = (props) => (
  <svg
    width={20}
    height={20}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 19.375a8.75 8.75 0 1 0-7.613-4.434L1.25 19.375l4.572-1.06A8.711 8.711 0 0 0 10 19.375Zm0-1.346a7.404 7.404 0 1 0-6.068-3.16l-.663 2.487 2.531-.633A7.37 7.37 0 0 0 10 18.03Z'
      fill='#BFC8D0'
    />
    <path
      d='M17.5 10a7.5 7.5 0 0 1-11.755 6.177l-2.563.641.672-2.519A7.5 7.5 0 1 1 17.5 10Z'
      fill='url(#whatsapp_svg__a)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 18.75a8.75 8.75 0 1 0-7.613-4.434L1.25 18.75l4.572-1.06A8.711 8.711 0 0 0 10 18.75Zm0-1.346a7.404 7.404 0 1 0-6.068-3.16L3.27 16.73l2.531-.633a7.37 7.37 0 0 0 4.2 1.306Z'
      fill='#fff'
    />
    <path
      d='M7.813 5.938c-.209-.418-.528-.381-.85-.381-.576 0-1.475.69-1.475 1.974 0 1.053.464 2.205 2.027 3.93 1.509 1.663 3.49 2.523 5.136 2.494 1.646-.03 1.984-1.445 1.984-1.923 0-.212-.131-.318-.222-.347-.56-.269-1.595-.77-1.83-.865-.235-.094-.358.034-.435.103-.213.203-.636.803-.78.938-.146.134-.362.066-.451.015-.331-.133-1.228-.531-1.942-1.224-.884-.857-.936-1.152-1.103-1.414-.133-.21-.035-.339.014-.395.19-.22.453-.56.571-.728.118-.168.024-.424-.032-.584-.241-.685-.446-1.26-.612-1.593Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        id='whatsapp_svg__a'
        x1={16.563}
        y1={4.375}
        x2={2.5}
        y2={17.5}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#5BD066' />
        <stop offset={1} stopColor='#27B43E' />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgWhatsapp;
